import debounce from '../debounce';

$(function () {
  const $container = $('#read-this-article-banner-container-hero');
  const $banner = $('#read-this-article-banner-container-hero .read-this-article-immersive');
  const $lockedFooter = $('#locked-footer');

  const calculateStickyClasses = function () {
    // resolve height bug with iOS - https://stackoverflow.com/a/22620066/985909
    const windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    const windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

    const topOfFooter = $container.position().top;
    const currentScrollPosition = windowHeight + $(window).scrollTop();

    const topOfPageFooter = $lockedFooter.position().top;

    // Ensure article title is visible, so on mobile, make banner sticky after the banner
    // container is scrolled past.
    if (windowWidth < 480) {
      if (currentScrollPosition > topOfFooter) {
        $banner.addClass('sticky');
        $banner.removeClass('xs-d:hidden');
      } else {
        $banner.removeClass('sticky');
        $banner.addClass('xs-d:hidden');
      }
    }

    // Hide banner when page footer is scrolled to
    if (windowHeight + window.scrollY > topOfPageFooter) {
      $banner.addClass('hide');
    } else {
      $banner.removeClass('hide');
    }
  };

  const debouncedCalculateStickyClasses = debounce(calculateStickyClasses, 25);

  if ($container.length) {
    $(window).scroll(calculateStickyClasses);
    $(window).resize(debouncedCalculateStickyClasses);
    $(window).on('load', calculateStickyClasses);
  }
});
